import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import { render } from 'nprogress'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/_login/index'),
    hidden: true
  },
  {
    path: '/password',
    component: () => import('@/views/_login/password'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/largeScreen',
    component: () => import('@/views/largeScreen'),
    hidden: true
  },
  {
    path: '/screen1',
    component: () => import('@/views/screen1'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/_home/index'),
      meta: { title: '首页', icon: 'home', requiresHome: true }
    }]
  },
  {
    path: '/no-access',
    component: Layout,
    hidden: true,
    children: [{ path: '', component: () => import('@/views/no-access'), meta: { title: '暂无访问权限' } }]
  },
  {
    path: '/log',
    component: Layout,
    meta: { title: '日志管理', icon: 'table' },
    children: [
      {
        path: 'log',
        name: 'Log',
        component: () => import('@/views/log/log'),
        meta: { title: '日志管理', icon: 'table' }
      },
    ]
  },
  {
    path: '/export',
    component: Layout,
    meta: { title: '导出管理', icon: 'table' },
    children: [
      {
        path: 'list',
        name: 'List',
        component: () => import('@/views/export/list'),
        meta: { title: '导出列表', icon: 'table' }
      },
    ]
  },
  {
    path: '/import',
    component: Layout,
    meta: { title: '导入管理', icon: 'table' },
    children: [
      {
        path: 'list',
        name: 'ImportList',
        component: () => import('@/views/import/list'),
        meta: { title: '导入列表', icon: 'table' }
      },
    ]
  },
  {
    path: '/system',
    component: Layout,
    meta: { title: '系统管理', icon: 'table' },
    children: [
      {
        path: 'sysMenu',
        name: 'SysMenu',
        component: () => import('@/views/system/sysMenu'),
        meta: { title: '菜单管理', icon: 'table' }
      },
      {
        path: 'sysRole',
        name: 'SysRole',
        component: () => import('@/views/system/sysRole'),
        meta: { title: '角色管理', icon: 'table' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/system/user'),
        meta: { title: '账号管理', icon: 'table' }
      },
      {
        path: 'userIdentity',
        name: 'UserIdentity',
        component: () => import('@/views/system/userIdentity'),
        meta: { title: '用户身份', icon: 'table' }
      },
      {
        path: 'discount',
        name: 'Discount',
        component: () => import('@/views/system/discount'),
        meta: { title: '折扣配置', icon: 'table' }
      },
      {
        path: 'taskList',
        name: 'TaskList',
        component: () => import('@/views/system/taskList'),
        meta: { title: '任务列表', icon: 'table' }
      },
      {
        path: 'sysNotice',
        name: 'SysNotice',
        component: () => import('@/views/system/sysNotice'),
        meta: { title: '系统通知', icon: 'table' }
      },
      {
        path: 'appVersion',
        name: 'appVersion',
        component: () => import('@/views/system/appVersion'),
        meta: { title: '版本管理', icon: 'table' }
      },
      {
        path: 'onlineEnvironment',
        name: 'OnlineEnvironment',
        component: () => import('@/views/system/onlineEnvironment'),
        meta: { title: 'APP隐藏课程', icon: 'table' }
      },
      {
        path: 'address',
        name: 'Address',
        component: () => import('@/views/system/address'),
        meta: { title: '地址管理', icon: 'table' }
      }
    ]
  },
  {
    path: '/goods',
    component: Layout,
    meta: { title: '商品管理', icon: 'table' },
    children: [
      {
        path: 'classify',
        name: 'Classify',
        component: () => import('@/views/goods/classify'),
        meta: { title: '商品分类', icon: 'table' }
      },
      {
        path: 'tag',
        name: 'Tag',
        component: () => import('@/views/goods/tag'),
        meta: { title: '商品标签', icon: 'table' }
      },
      {
        path: 'goods',
        name: 'Goods',
        component: () => import('@/views/goods/goods'),
        meta: { title: '商品管理', icon: 'table' }
      },
      {
        path: 'seckill',
        name: 'Seckill',
        component: () => import('@/views/goods/seckill'),
        meta: { title: '秒杀商品', icon: 'table' }
      },
      {
        path: 'activity',
        name: 'Activity',
        component: () => import('@/views/goods/activity'),
        meta: { title: '活动管理', icon: 'table' }
      },
      {
        path: 'activityRewardLog',
        name: 'ActivityRewardLog',
        component: () => import('@/views/goods/activityRewardLog'),
        meta: { title: '活动发放流水', icon: 'table' }
      },
      {
        path: 'outboundGoods',
        name: 'OutboundGoods',
        component: () => import('@/views/goods/outboundGoods'),
        meta: { title: '出库商品管理', icon: 'table' }
      },
    ]
  },
  {
    path: '/integral',
    component: Layout,
    meta: { title: '积分商品', icon: 'table' },
    children: [
      {
        path: 'classify',
        name: 'Classify',
        component: () => import('@/views/integral/classify'),
        meta: { title: '积分商品分类', icon: 'table' }
      },
      {
        path: 'integralGoods',
        name: 'IntegralGoods',
        component: () => import('@/views/integral/integralGoods'),
        meta: { title: '积分商品', icon: 'table' }
      },
    ]
  },
  {
    path: '/order',
    component: Layout,
    meta: { title: '订单管理', icon: 'table' },
    children: [
      {
        path: 'goodsorder',
        name: 'Goodsorder',
        component: () => import('@/views/order/goodsorder'),
        meta: { title: '商城订单', icon: 'table' }
      },
      {
        path: 'integralorder',
        name: 'Integralorder',
        component: () => import('@/views/order/integralorder'),
        meta: { title: '积分订单', icon: 'table' }
      },
      {
        path: 'afterorder',
        name: 'Afterorder',
        component: () => import('@/views/order/afterorder'),
        meta: { title: '售后订单', icon: 'table' }
      },
      {
        path: 'claimOrder',
        name: 'ClaimOrder',
        component: () => import('@/views/order/claimOrder'),
        meta: { title: '待认领售后订单', icon: 'table' }
      },
      {
        path: 'changeorder',
        name: 'Changeorder',
        component: () => import('@/views/order/changeorder'),
        meta: { title: '换货订单', icon: 'table' }
      },
      {
        path: 'registrationGiftlist',
        name: 'registrationGiftlist',
        component: () => import('@/views/order/registrationGiftlist'),
        meta: { title: '升级礼包', icon: 'table' }
      },
      {
        path: 'outboundOrder',
        name: 'OutboundOrder',
        component: () => import('@/views/order/outboundOrder'),
        meta: { title: '出库订单', icon: 'table' }
      },
      // REQ-2026-826259 虚拟单自动流转记录。
      // 这里的静态路由必须和 sys_menu 里的菜单一起加：菜单只管侧边栏显不显示，
      // 路由表是硬编码的，只建菜单不注册路由 = 侧边栏有这一项、点进去 404。
      {
        path: 'virtualAutoLog',
        name: 'VirtualAutoLog',
        component: () => import('@/views/order/virtualAutoLog'),
        meta: { title: '虚拟单自动流转', icon: 'table' }
      },
    ]
  },
  {
    path: '/config',
    component: Layout,
    meta: { title: '配置管理', icon: 'table' },
    children: [
      {
        path: 'basics',
        name: 'Basics',
        component: () => import('@/views/config/basics'),
        meta: { title: '基础配置', icon: 'table' }
      },
      {
        path: 'express',
        name: 'Express',
        component: () => import('@/views/config/express'),
        meta: { title: '快递配置', icon: 'table' }
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/config/banner'),
        meta: { title: '广告位', icon: 'table' }
      },
      {
        path: 'youAccount',
        name: 'YouAccount',
        component: () => import('@/views/config/youAccount'),
        meta: { title: '用友账套管理', icon: 'table' }
      },
      {
        path: 'department',
        name: 'Department',
        component: () => import('@/views/config/department'),
        meta: { title: '部门管理', icon: 'table' }
      },
      {
        path: 'customerClass',
        name: 'CustomerClass',
        component: () => import('@/views/config/customerClass'),
        meta: { title: '客户分类', icon: 'table' }
      },
      {
        path: 'giveReason',
        name: 'GiveReason',
        component: () => import('@/views/config/giveReason'),
        meta: { title: '赠送账户原因', icon: 'table' }
      },
      {
        path: 'standards',
        name: 'Standards',
        component: () => import('@/views/config/standards'),
        meta: { title: '达标标准', icon: 'table' }
      },
      {
        path: 'dueBank',
        name: 'dueBank',
        component: () => import('@/views/config/dueBank'),
        meta: { title: '收款银行配置', icon: 'table' }
      },
      {
        path: 'platformPay',
        name: 'platformPay',
        component: () => import('@/views/config/platformPay'),
        meta: { title: '平台支付方式管理', icon: 'table' }
      }
    ]
  },
  {
    path: '/clue',
    component: Layout,
    meta: { title: '线索管理', icon: 'table' },
    children: [
      {
        path: 'myClue',
        name: 'MyClue',
        component: () => import('@/views/clue/myClue'),
        meta: { title: '我的线索', icon: 'table' }
      },
      {
        path: 'publicClue',
        name: 'PublicClue',
        component: () => import('@/views/clue/publicClue'),
        meta: { title: '线索公海', icon: 'table' }
      }
    ]
  },
  {
    path: '/client',
    component: Layout,
    meta: { title: '客户管理', icon: 'table' },
    children: [
      {
        path: 'labelClient',
        name: 'LabelClient',
        component: () => import('@/views/client/labelClient'),
        meta: { title: '标签管理', icon: 'table' }
      },
      {
        path: 'clientList',
        name: 'ClientList',
        component: () => import('@/views/client/clientList'),
        meta: { title: '客户列表', icon: 'table' }
      },
      {
        path: 'publicClient',
        name: 'PublicClient',
        component: () => import('@/views/client/publicClient'),
        meta: { title: '客户公海', icon: 'table' }
      },
      {
        path: 'bigClient',
        name: 'BigClient',
        component: () => import('@/views/client/bigClient'),
        meta: { title: '大客户', icon: 'table' }
      },
      {
        path: 'followCustRecordType',
        name: 'followCustRecordType',
        component: () => import('@/views/client/followCustRecordType/list'),
        meta: { title: '客户跟进类型', icon: 'table' }
      },
      {
        path: 'otherFollowCustRecord',
        name: 'OtherFollowCustRecord',
        component: () => import('@/views/client/otherFollowCustRecord/index'),
        meta: { title: '其他跟进记录', icon: 'table' }
      }
    ]
  },
  {
    path: '/business',
    component: Layout,
    meta: { title: '业务管理', icon: 'table' },
    children: [
      {
        path: 'businessList',
        name: 'BusinessList',
        component: () => import('@/views/business/businessList'),
        meta: { title: '业务管理', icon: 'table' }
      },
      {
        path: 'businessExamine',
        name: 'BusinessExamine',
        component: () => import('@/views/business/businessExamine'),
        meta: { title: '业务审核', icon: 'table' }
      },
      {
        path: 'cityCorporation',
        name: 'CityCorporation',
        component: () => import('@/views/business/cityCorporation'),
        meta: { title: '城市公司', icon: 'table' }
      },
      {
        path: 'cityCorporation/qrcodeList',
        name: 'CityCorporationQrcodeList',
        component: () => import('@/views/business/cityCorporation/qrcodeList'),
        meta: { title: '静态码管理', icon: 'table' }
      }
    ]
  },
  {
    path: '/interior',
    component: Layout,
    meta: { title: '内部员工', icon: 'table' },
    children: [
      {
        path: 'sectionList',
        name: 'SectionList',
        component: () => import('@/views/interior/sectionList'),
        meta: { title: '部门管理', icon: 'table' }
      },
      {
        path: 'internalEmployee',
        name: 'InternalEmployee',
        component: () => import('@/views/interior/internalEmployee'),
        meta: { title: '内部员工', icon: 'table' }
      }
    ]
  },
  {
    path: '/technical',
    component: Layout,
    meta: { title: '技术管理', icon: 'table' },
    children: [
      {
        path: 'technicalManage',
        name: 'TechnicalManage',
        component: () => import('@/views/technical/technicalManage'),
        meta: { title: '技术管理', icon: 'table' }
      },
      {
        path: 'reservation',
        name: 'Reservation',
        component: () => import('@/views/technical/reservation'),
        meta: { title: '预约服务', icon: 'table' }
      },
      {
        path: 'indicator',
        name: 'Indicator',
        component: () => import('@/views/technical/indicator'),
        meta: { title: '指标配置', icon: 'table' }
      },
      {
        path: 'edCompany',
        name: 'EdCompany',
        component: () => import('@/views/technical/edCompany'),
        meta: { title: '教育公司管理', icon: 'table' }
      },
      {
        path: 'serviceTeacher',
        name: 'ServiceTeacher',
        component: () => import('@/views/technical/serviceTeacher'),
        meta: { title: '带教老师管理', icon: 'table' }
      },
    ]
  },
  {
    path: '/finance',
    component: Layout,
    meta: { title: '财务管理', icon: 'table' },
    children: [
      {
        path: 'intentDeposit',
        name: 'IntentDepositLedger',
        component: () => import('@/views/finance/intentDeposit'),
        meta: { title: '意向金订单台账', icon: 'table' }
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        component: () => import('@/views/finance/withdraw'),
        meta: { title: '提现管理', icon: 'table' }
      },
      {
        path: 'proofAudit',
        name: 'ProofAudit',
        component: () => import('@/views/finance/proofAudit'),
        meta: { title: '付款凭证审核', icon: 'table' }
      },
      {
        path: 'authenticationAudit',
        name: 'AuthenticationAudit',
        component: () => import('@/views/finance/authenticationAudit'),
        meta: { title: '认证审核', icon: 'table' }
      },
      {
        path: 'businessAudit',
        name: 'BusinessAudit',
        component: () => import('@/views/finance/businessAudit'),
        meta: { title: '业务审核', icon: 'table' }
      },
      {
        path: 'subaccountAudit',
        name: 'SubaccountAudit',
        component: () => import('@/views/finance/subaccountAudit'),
        meta: { title: '子账号审核', icon: 'table' }
      },
      {
        path: 'subaccountFollowup',
        name: 'SubaccountFollowup',
        component: () => import('@/views/finance/subaccountFollowup'),
        meta: { title: '子账号回访', icon: 'table' }
      },
      {
        path: 'account',
        name: 'Account',
        component: () => import('@/views/finance/account'),
        meta: { title: '账户管理', icon: 'table' }
      },
      {
        path: 'reconciliation',
        name: 'Reconciliation',
        component: () => import('@/views/finance/reconciliation'),
        meta: { title: '对账', icon: 'table' }
      },
      {
        path: 'regionReward',
        name: 'RegionReward',
        component: () => import('@/views/finance/regionReward'),
        meta: { title: '大区奖励核算', icon: 'table' }
      },
      {
        path: 'offlineRegistrationAudit',
        name: 'OfflineRegistrationAudit',
        component: () => import('@/views/finance/offlineRegistrationAudit'),
        meta: { title: '线下报名审核', icon: 'table' }
      },
      {
        path: 'discountModificationAudit',
        name: 'DiscountModificationAudit',
        component: () => import('@/views/finance/discountModificationAudit'),
        meta: { title: '折扣修改审核', icon: 'table' }
      },
      {
        path: 'rechargeManualLedgerAudit',
        name: 'RechargeManualLedgerAudit',
        component: () => import('@/views/finance/rechargeManualLedgerAudit'),
        meta: { title: '充值手动上账审核', icon: 'table' }
      },
      {
        path: 'customerIdentityChangeAudit',
        name: 'CustomerIdentityChangeAudit',
        component: () => import('@/views/finance/customerIdentityChangeAudit'),
        meta: { title: '客户身份变动审核', icon: 'table' }
      },
      {
        path: 'invoiceApplicationAudit',
        name: 'InvoiceApplicationAudit',
        component: () => import('@/views/finance/invoiceApplicationAudit'),
        meta: { title: '发票申请审核', icon: 'table' }
      },
      {
        path: 'outboundAudit',
        name: 'OutboundAudit',
        component: () => import('@/views/finance/outboundAudit'),
        meta: { title: '其他出库订单审核', icon: 'table' }
      },
      {
        path: 'payManage',
        name: 'PayManage',
        component: () => import('@/views/finance/payManage'),
        meta: { title: '支付管理', icon: 'table' }
      }
    ]
  },
  {
    path: '/submitAuditRecord',
    component: Layout,
    redirect: '/submitAuditRecord/discountRecord',
    meta: { title: '提交审核记录', icon: 'table' },
    children: [
      {
        path: 'discountRecord',
        name: 'DiscountRecord',
        component: () => import('@/views/submitAuditRecord/discountRecord'),
        meta: { title: '折扣记录', icon: 'table' }
      },
      {
        path: 'rechargeRecord',
        name: 'RechargeRecord',
        component: () => import('@/views/submitAuditRecord/rechargeRecord'),
        meta: { title: '充值手动上账记录', icon: 'table' }
      }
    ]
  },
  {
    // ⚠️ 老的「AI场景管理」（对接 ai-exam-system，101.42.137.155）。
    // **这不是原型，是生产在用的功能**：生产 sys_menu 里有 370/371/372 三条菜单，
    // 372 的 res_code 就是 `/ai/scenario`。**删掉这个路由 = 侧边栏还在、点进去 404**。
    // AI训战是**另外新增**的 /aiTrain，两者并存，不是替代关系。
    path: '/ai',
    component: Layout,
    meta: { title: 'AI场景管理', icon: 'el-icon-cpu' },
    children: [
      {
        path: 'scenario',
        name: 'ScenarioManagement',
        component: () => import('@/views/ai/scenario'),
        meta: { title: '场景管理', icon: 'el-icon-setting' }
      }
    ]
  },
  {
    // REQ-2026-117533 AI训战：新建 duyisheng-ai-train-server 独立后端 + 独立菜单。
    // ⚠️ 与上面的 /ai **并存**，不要再把 /ai 当成"老原型"删掉。
    path: '/aiTrain',
    component: Layout,
    meta: { title: 'AI训战', icon: 'el-icon-cpu' },
    children: [
      {
        path: 'category',
        name: 'AiTrainCategory',
        component: () => import('@/views/aiTrain/category'),
        meta: { title: '分类管理', icon: 'el-icon-menu' }
      },
      {
        path: 'scene',
        name: 'AiTrainScene',
        component: () => import('@/views/aiTrain/scene'),
        meta: { title: '场景管理', icon: 'el-icon-chat-line-round' }
      },
      {
        path: 'scoreTemplate',
        name: 'AiTrainScoreTemplate',
        component: () => import('@/views/aiTrain/scoreTemplate'),
        meta: { title: '评分表', icon: 'el-icon-tickets' }
      },
      {
        path: 'auth',
        name: 'AiTrainAuth',
        component: () => import('@/views/aiTrain/auth'),
        meta: { title: '场景权限', icon: 'el-icon-key' }
      },
      {
        path: 'permission',
        name: 'AiTrainPermission',
        component: () => import('@/views/aiTrain/permission'),
        meta: { title: '权限管理', icon: 'el-icon-s-grid' }
      },
      {
        path: 'tier',
        name: 'AiTrainTier',
        component: () => import('@/views/aiTrain/tier'),
        meta: { title: '难度档配置', icon: 'el-icon-sort' }
      },
      {
        path: 'record',
        name: 'AiTrainRecord',
        component: () => import('@/views/aiTrain/record'),
        meta: { title: '训练记录', icon: 'el-icon-document' }
      },
      {
        path: 'knowledge',
        name: 'AiTrainKnowledge',
        component: () => import('@/views/aiTrain/knowledge'),
        meta: { title: '知识库', icon: 'el-icon-notebook-2' }
      }
    ]
  },
  {
    path: '/yyPush',
    component: Layout,
    meta: { title: '用友推送', icon: 'table' },
    children: [
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/yyPush/order'),
        meta: { title: '推送订单', icon: 'table' }
      },
      // {
      //   path: 'cancelOrder',
      //   name: 'CancelOrder',
      //   component: () => import('@/views/yyPush/cancelOrder'),
      //   meta: { title: '推送取消订单', icon: 'table' }
      // },
      {
        path: 'receipt',
        name: 'Receipt',
        component: () => import('@/views/yyPush/receipt'),
        meta: { title: '推送收款单', icon: 'table' }
      },
      {
        path: 'paymentOrder',
        name: 'PaymentOrder',
        component: () => import('@/views/yyPush/paymentOrder'),
        meta: { title: '推送付款单', icon: 'table' }
      },
      {
        path: 'refundOrder',
        name: 'RefundOrder',
        component: () => import('@/views/yyPush/refundOrder'),
        meta: { title: '推送退款单', icon: 'table' }
      },
      {
        path: 'userinfo',
        name: 'Userinfo',
        component: () => import('@/views/yyPush/userinfo'),
        meta: { title: '推送用户信息', icon: 'table' }
      },
      {
        path: 'transferCityCompany',
        name: 'TransferCityCompany',
        component: () => import('@/views/yyPush/TransferCityCompany'),
        meta: { title: '推送用友转移城市公司', icon: 'table' }
      },{
        path: 'paymentVoucher',
        name: 'PaymentVoucher',
        component: () => import('@/views/yyPush/paymentVoucher'),
        meta: { title: '推送用友凭证记录', icon: 'table' }
      }
    ]
  },
  {
    path: '/customer',
    component: Layout,
    meta: { title: '客服管理', icon: 'table' },
    children: [
      {
        path: 'personnelManage',
        name: 'PersonnelManage',
        component: () => import('@/views/customer/personnelManage'),
        meta: { title: '客服人员管理', icon: 'table' }
      },
      {
        path: 'message',
        name: 'Message',
        component: () => import('@/views/customer/message'),
        meta: { title: '消息管理', icon: 'table' }
      },
      {
        path: 'archive',
        name: 'Archive',
        component: () => import('@/views/customer/archive'),
        meta: { title: '归档管理', icon: 'table' }
      },
      {
        path: 'sessionManage',
        name: 'SessionManage',
        component: () => import('@/views/customer/sessionManage'),
        meta: { title: '会话管理', icon: 'table' }
      },
      {
        path: 'autoReply',
        name: 'AutoReply',
        component: () => import('@/views/customer/autoReply'),
        meta: { title: '自动回复管理', icon: 'table' }
      },
      {
        path: 'phrases',
        name: 'Phrases',
        component: () => import('@/views/customer/phrases'),
        meta: { title: '常用语', icon: 'table' }
      },
      {
        path: 'learn',
        name: 'Learn',
        component: () => import('@/views/customer/learn'),
        meta: { title: '知识库', icon: 'table' }
      },
      {
        path: 'consulted',
        name: 'Consulted',
        component: () => import('@/views/customer/consulted'),
        meta: { title: '猜你咨询', icon: 'table' }
      },
      {
        path: 'problem',
        name: 'Problem',
        component: () => import('@/views/customer/problem'),
        meta: { title: '咨询问题', icon: 'table' }
      },
    ]
  },
  // 【开放接口管理】REQ-2026-238755
  // 侧边栏层级由 sys_menu.parent_id 决定（挂在【系统管理】下），
  // 但 路径→组件 的映射只在本文件里 —— 跟 /complaint、/projectLanding 是同一个模式。
  // ⚠️ 只建 sys_menu 不在这里注册 = 侧边栏点得到、点进去 404
  //    （被文件末尾的 { path: '*', redirect: '/404' } 兜底吞掉，而且不报错）。
  //    sys_menu.res_code 必须与下面三个路径逐字一致：
  //      /openapi/catalog、/openapi/key、/openapi/monitor
  {
    path: '/openapi',
    component: Layout,
    meta: { title: '开放接口管理', icon: 'table' },
    children: [
      {
        path: 'catalog',
        name: 'OpenapiCatalog',
        component: () => import('@/views/openapi/catalog'),
        meta: { title: '对外接口清单', icon: 'table' }
      },
      {
        path: 'key',
        name: 'OpenapiKey',
        component: () => import('@/views/openapi/key'),
        meta: { title: 'API Key 管理', icon: 'table' }
      },
      {
        path: 'monitor',
        name: 'OpenapiMonitor',
        component: () => import('@/views/openapi/monitor'),
        meta: { title: '调用监控', icon: 'table' }
      }
    ]
  },
  // 【客诉反馈】REQ-2026-632570
  // 侧边栏里这两个页面挂在【客服管理】(sys_menu id=48) 下面，层级由 sys_menu.parent_id 决定；
  // 但路由必须在这里注册成顶层 + Layout —— 跟 /projectLanding 是同一个模式。
  // ⚠️ 只建 sys_menu 是不够的：getRouters 只驱动侧边栏渲染，
  //    真正的 路径→组件 映射全在本文件里。漏了这块 = 侧边栏点得到、点进去 404
  //    （被文件末尾的 { path: '*', redirect: '/404' } 兜底吞掉）。
  //    sys_menu 的 res_code 必须与下面的路径一致：/complaint/feedback、/complaint/type
  {
    path: '/complaint',
    component: Layout,
    meta: { title: '客诉反馈', icon: 'table' },
    children: [
      {
        path: 'feedback',
        name: 'ComplaintFeedback',
        component: () => import('@/views/complaint/feedback'),
        meta: { title: '客诉反馈管理', icon: 'table' }
      },
      {
        path: 'type',
        name: 'ComplaintType',
        component: () => import('@/views/complaint/type'),
        meta: { title: '反馈类型配置', icon: 'table' }
      }
    ]
  },
  // 【AI 回复记录】REQ-2026-574277（原「AI 回复审核」，二期修订后改成只读回查页；
  //  审核操作并入了 客服服务 → 消息管理 的内联草稿卡片。path 不变，sys_menu.res_code 仍是 /aiCs/review）
  // 同样是"顶层 + Layout"的模式：侧边栏层级由 sys_menu.parent_id 决定（挂在【客服管理】下），
  // 但 路径→组件 的映射只在本文件里。
  // ⚠️ 只建 sys_menu 不在这里注册 = 侧边栏点得到、点进去 404，
  //    而且动态路由注册失败还会连累同级菜单。sys_menu.res_code 必须等于 /aiCs/review。
  {
    path: '/aiCs',
    component: Layout,
    meta: { title: 'AI客服', icon: 'table' },
    children: [
      {
        path: 'review',
        name: 'AiCsReview',
        component: () => import('@/views/aiCs/review'),
        meta: { title: 'AI回复记录', icon: 'table' }
      }
    ]
  },
  {
    path: '/course',
    component: Layout,
    meta: { title: '课程管理', icon: 'table' },
    children: [
      {
        path: 'classify',
        name: 'Classify',
        component: () => import('@/views/course/classify'),
        meta: { title: '课程分类', icon: 'table' }
      },
      {
        path: 'welfareClassify',
        name: 'WelfareClassify',
        component: () => import('@/views/course/welfareClassify'),
        meta: { title: '福利分类', icon: 'table' }
      },
      {
        path: 'welfare',
        name: 'Welfare',
        component: () => import('@/views/course/welfare'),
        meta: { title: '新用户福利', icon: 'table' }
      },
      {
        path: 'lecturerLevel',
        name: 'LecturerLevel',
        component: () => import('@/views/course/lecturerLevel'),
        meta: { title: '讲师等级', icon: 'table' }
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/course/course'),
        meta: { title: '课程管理', icon: 'table' }
      },
      {
        path: 'lecturerExams',
        name: 'LecturerExamSummary',
        component: () => import('@/views/course/examRecords/lecturer'),
        meta: { title: '负责课程考试', icon: 'table' }
      },
      {
        path: 'lecturer',
        name: 'Lecturer',
        component: () => import('@/views/course/lecturer'),
        meta: { title: '讲师管理', icon: 'table' }
      },
      {
        path: 'scene',
        name: 'Scene',
        component: () => import('@/views/course/scene'),
        meta: { title: '情景练习', icon: 'table' }
      },
      {
        path: 'topicClass',
        name: 'TopicClass',
        component: () => import('@/views/course/topicClass'),
        meta: { title: '题目分类', icon: 'table' }
      },
      {
        path: 'topic',
        name: 'Topic',
        component: () => import('@/views/course/topic'),
        meta: { title: '题目管理', icon: 'table' }
      },
      {
        path: 'grade',
        name: 'Grade',
        component: () => import('@/views/course/grade'),
        meta: { title: '学分等级配置', icon: 'table' }
      },
      {
        path: 'challenge',
        name: 'Challenge',
        component: () => import('@/views/course/challenge'),
        meta: { title: '闯关模式', icon: 'table' }
      },
      {
        path: 'sceneRecords',
        name: 'SceneRecords',
        component: () => import('@/views/course/sceneRecords'),
        meta: { title: '情景回答记录', icon: 'table' }
      },
      {
        path: 'examRecords',
        name: 'ExamRecords',
        component: () => import('@/views/course/examRecords'),
        meta: { title: '考试记录', icon: 'table' }
      },
      {
        path: 'passRecords',
        name: 'PassRecords',
        component: () => import('@/views/course/passRecords'),
        meta: { title: '闯关记录', icon: 'table' }
      },
      {
        path: 'courseOrder',
        name: 'CourseOrder',
        component: () => import('@/views/course/courseOrder'),
        meta: { title: '课程订单', icon: 'table' }
      },
      {
        path: 'freeCourses',
        name: 'FreeCourses',
        component: () => import('@/views/course/freeCourses'),
        meta: { title: '赠送课程', icon: 'table' }
      }
    ]
  },
  {
    path: '/meeting',
    component: Layout,
    meta: { title: '会议管理', icon: 'table' },
    children: [
      {
        path: 'meetingClassify',
        name: 'MeetingClassify',
        component: () => import('@/views/meeting/meetingClassify'),
        meta: { title: '会议分类', icon: 'table' }
      },
      {
        path: 'meetingList',
        name: 'MeetingList',
        component: () => import('@/views/meeting/meetingList'),
        meta: { title: '会议列表', icon: 'table' }
      },
      {
        path: 'mainImage',
        name: 'MainImage',
        component: () => import('@/views/meeting/mainImage'),
        meta: { title: '会议主图', icon: 'table' }
      },
      {
        path: 'record',
        name: 'Record',
        component: () => import('@/views/meeting/record'),
        meta: { title: '报名记录', icon: 'table' }
      },
    ]
  },
  {
    path: '/count',
    component: Layout,
    meta: { title: '数据统计', icon: 'table' },
    children: [
      {
        path: '/count/business',
        name: 'business',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/business',
        meta: { title: '业务统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'Business',
            component: () => import('@/views/count/business'),
            meta: { title: '业务统计', icon: 'table' },
          },
          {
            path: 'team',
            name: 'Team',
            component: () => import('@/views/count/business/team'),
            meta: { title: '团队成员', icon: 'table' }
          },
          {
            path: 'customer',
            name: 'Customer',
            component: () => import('@/views/count/business/customer'),
            meta: { title: '客户', icon: 'table' }
          },
          {
            path: 'achievement',
            name: 'Achievement',
            component: () => import('@/views/count/business/achievement'),
            meta: { title: '业绩', icon: 'table' }
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/business/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      {
        path: '/count/serviceTeacher',
        name: 'serviceTeacher',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/serviceTeacher',
        meta: { title: '带教老师统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'ServiceTeacher',
            component: () => import('@/views/count/serviceTeacher'),
            meta: { title: '带教老师统计', icon: 'table' },
          }
        ]
      },
      {
        path: '/count/technology',
        name: 'technology',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/technology',
        meta: { title: '技术统计', icon: 'table' },
        children: [
            {
              path: '',
              name: 'Technology',
              component: () => import('@/views/count/technology'),
            meta: { title: '技术统计', icon: 'table' },
          },
          {
            path: 'team',
            name: 'Team',
            component: () => import('@/views/count/technology/team'),
            meta: { title: '团队成员', icon: 'table' }
          },
          {
            path: 'customer',
            name: 'Customer',
            component: () => import('@/views/count/technology/customer'),
            meta: { title: '客户', icon: 'table' }
          },
          {
            path: 'achievement',
            name: 'Achievement',
            component: () => import('@/views/count/technology/achievement'),
            meta: { title: '业绩', icon: 'table' }
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/technology/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      // 教培数据统计（REQ-2026-125349）：技术老师签到与出货 / 客户数据明细 / 新加盟客户年度进货
      {
        path: '/count/eduStats',
        name: 'eduStats',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/eduStats',
        meta: { title: '教培数据统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'EduStats',
            component: () => import('@/views/count/eduStats'),
            meta: { title: '教培数据统计', icon: 'table' }
          }
        ]
      },
      // {
      //   path: '/count/kickback',
      //   name: 'kickback',
      //   component: { render(c) { return c('router-view') } },
      //   redirect: '/count/kickback',
      //   meta: { title: '佣金统计', icon: 'table' },
      //   children: [
      //     {
      //       path: '/count/kickback',
      //       name: 'Kickback',
      //       component: () => import('@/views/count/kickback')
      //     },
      //     {
      //       path: 'commission',
      //       name: 'Eommission',
      //       component: () => import('@/views/count/kickback/commission'),
      //       meta: { title: '佣金', icon: 'table' }
      //     },
      //     {
      //       path: 'export',
      //       name: 'Export',
      //       component: () => import('@/views/count/kickback/export'),
      //       meta: { title: '导出', icon: 'table' }
      //     }
      //   ]
      // },
      {
        path: '/count/getGoods',
        name: 'getGoods',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/getGoods',
        meta: { title: '拿货统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'GetGoods',
            component: () => import('@/views/count/getGoods'),
            meta: { title: '拿货统计', icon: 'table' },
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/getGoods/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      {
        path: '/count/sales',
        name: 'sales',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/sales',
        meta: { title: '城市公司销售统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'Sales',
            component: () => import('@/views/count/sales'),
            meta: { title: '城市公司销售统计', icon: 'table' },
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/sales/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      {
        path: '/count/afterSales',
        name: 'afterSales',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/afterSales',
        meta: { title: '售后统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'AfterSales',
            component: () => import('@/views/count/afterSales'),
            meta: { title: '售后统计', icon: 'table' }
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/afterSales/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      {
        path: '/count/goodsRanking',
        name: 'goodsRanking',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/goodsRanking',
        meta: { title: '售后商品排行', icon: 'table' },
        children: [
          {
            path: '',
            name: 'Sales',
            component: () => import('@/views/count/goodsRanking'),
            meta: { title: '售后商品排行', icon: 'table' }
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/goodsRanking/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      {
        path: '/count/courseRanking',
        name: 'courseRanking',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/courseRanking',
        meta: { title: '课程排行', icon: 'table' },
        children: [
          {
            path: '',
            name: 'CourseRanking',
            component: () => import('@/views/count/courseRanking'),
            meta: { title: '课程排行', icon: 'table' },
          },
          {
            path: 'customer',
            name: 'Customer',
            component: () => import('@/views/count/courseRanking/customer'),
            meta: { title: '客户', icon: 'table' }
          },
          {
            path: 'export',
            name: 'Export',
            component: () => import('@/views/count/courseRanking/export'),
            meta: { title: '导出', icon: 'table' }
          }
        ]
      },
      {
        path: '/count/study',
        name: 'study',
        component: { render(c) { return c('router-view') } },
        redirect: '/count/study',
        meta: { title: '学习统计', icon: 'table' },
        children: [
          {
            path: '',
            name: 'Study',
            component: () => import('@/views/count/study'),
            meta: { title: '学习统计', icon: 'table' },
          }
        ]
      },
      {
        path: 'areaExport',
        name: 'AreaExport',
        component: () => import('@/views/count/areaExport'),
        meta: { title: '大区导出', icon: 'table' }
      },

    ]
  },
  {
    path: '/recharge',
    component: Layout,
    meta: { title: '充值管理', icon: 'table' },
    children: [
      {
        path: 'activity',
        name: 'Activity',
        component: () => import('@/views/recharge/activity'),
        meta: { title: '充值活动', icon: 'table' }
      },
      {
        path: 'record',
        name: 'Record',
        component: () => import('@/views/recharge/record'),
        meta: { title: '充值记录', icon: 'table' }
      },
    ]
  },
  {
    path: '/archives',
    component: Layout,
    meta: { title: '档案管理', icon: 'table' },
    children: [
      {
        path: 'fileManage',
        name: 'FileManage',
        component: () => import('@/views/archives/fileManage'),
        meta: { title: '档案管理', icon: 'table' }
      },
      {
        path: 'skinTesting',
        name: 'SkinTesting',
        component: () => import('@/views/archives/skinTesting'),
        meta: { title: '皮肤检测记录', icon: 'table' }
      },
      {
        path: 'disease',
        name: 'disease',
        component: () => import('@/views/archives/disease'),
        meta: { title: '疾病名称管理', icon: 'table' }
      },
      {
        path: 'marketing',
        name: 'Marketing',
        component: () => import('@/views/archives/marketing'),
        meta: { title: '活动营销', icon: 'table' }
      }
    ]
  },
  {
    path: '/marketing',
    component: Layout,
    meta: { title: '营销管理', icon: 'table' },
    children: [
      {
        path: 'functionType',
        name: 'FunctionType',
        component: () => import('@/views/marketing/functionType'),
        meta: { title: '功能类型', icon: 'table' }
      }, {
        // 原【营销管理 - 项目落地资料包】(/marketing/projectMaterial) 已下线，
        // 页面整体搬到 /projectLanding/material，见本文件的 /projectLanding 块。
        path: 'marketingCategory',
        name: 'MarketingCategory',
        component: () => import('@/views/marketing/marketingCategory'),
        meta: { title: '营销分类配置', icon: 'table' }
      }, {
        path: 'project',
        name: 'Project',
        component: () => import('@/views/marketing/project'),
        meta: { title: '项目管理', icon: 'table' }
      }, {
        path: 'customerMaterial',
        name: 'CustomerMaterial',
        component: () => import('@/views/marketing/customerMaterial'),
        meta: { title: '顾客物料', icon: 'table' }
      },
      {
        path: 'shareMaterial',
        name: 'ShareMaterial',
        component: () => import('@/views/marketing/shareMaterial'),
        meta: { title: '分享物料/图文模块', icon: 'table' }
      },
      {
        path: 'shareAnalysis',
        name: 'shareAnalysis',
        component: () => import('@/views/marketing/shareAnalysis'),
        meta: { title: '物料分享分析', icon: 'table' }
      },
      {
        path: 'promotional',
        name: 'Promotional',
        component: () => import('@/views/marketing/promotional'),
        meta: { title: '技术老师宣传图', icon: 'table' }
      },
      {
        path: 'anwerShow',
        name: 'anwerShow',
        component: () => import('@/views/marketing/anwerShow'),
        meta: { title: '案例展示', icon: 'table' }
      },
      {
        path: 'brandPromotion',
        name: 'brandPromotion',
        component: () => import('@/views/marketing/brandPromotion'),
        meta: { title: '品宣', icon: 'table' }
      },
      {
        path: 'businessMaterials',
        name: 'businessMaterials',
        component: () => import('@/views/marketing/businessMaterials'),
        meta: { title: '业务物料', icon: 'table' }
      },
      {
        path: 'dermatologicalMedicine',
        name: 'dermatologicalMedicine',
        component: () => import('@/views/marketing/dermatologicalMedicine'),
        meta: { title: '皮科普药', icon: 'table' }
      },
      {
        path: 'newMaterial',
        name: 'newMaterial',
        component: () => import('@/views/marketing/newMaterial'),
        meta: { title: '新闻咨询', icon: 'table' }
      },
      {
        path: 'patientMaterials',
        name: 'patientMaterials',
        component: () => import('@/views/marketing/patientMaterials'),
        meta: { title: '患者就诊物料', icon: 'table' }
      }
    ]
  },
  // 【项目落地】REQ-2026-759351
  // 侧边栏里它挂在【内容管理 - 营销管理】下面（层级由 sys_menu.parent_id 决定），
  // 但路由必须注册成顶层 + Layout —— 跟上面的 /marketing 是同一个模式。
  // ⚠️ 光在 sys_menu 建菜单是不够的：getRouters 只驱动侧边栏渲染，
  //    真正的 路径→组件 映射全在本文件里。漏了这块 = 侧边栏点得到、点进去 404
  //    （被文件末尾的 { path: '*', redirect: '/404' } 兜底吞掉）。
  {
    path: '/projectLanding',
    component: Layout,
    meta: { title: '项目落地', icon: 'table' },
    children: [
      {
        path: 'material',
        name: 'ProjectLandingMaterial',
        component: () => import('@/views/projectLanding/material'),
        meta: { title: '资料包管理', icon: 'table' }
      },
      {
        path: 'category',
        name: 'ProjectLandingCategory',
        component: () => import('@/views/projectLanding/category'),
        meta: { title: '分区与分类', icon: 'table' }
      },
      {
        path: 'banner',
        name: 'ProjectLandingBanner',
        component: () => import('@/views/projectLanding/banner'),
        meta: { title: '顶部Banner', icon: 'table' }
      },
      {
        path: 'entry',
        name: 'ProjectLandingEntry',
        component: () => import('@/views/projectLanding/entry'),
        meta: { title: 'App入口图标', icon: 'table' }
      }
    ]
  },
  {
    path: '/dataBoard',
    component: Layout,
    meta: { title: '数据看板', icon: 'table' },
    children: [
      {
        path: 'collection',
        name: 'Collection',
        component: () => import('@/views/dataBoard/collection'),
        meta: { title: '收款分析', icon: 'table' }
      },
      {
        path: 'shipment',
        name: 'Shipment',
        component: () => import('@/views/dataBoard/shipment'),
        meta: { title: '出货分析', icon: 'table' }
      },
      {
        path: 'conference',
        name: 'Conference',
        component: () => import('@/views/dataBoard/conference'),
        meta: { title: '会议分析', icon: 'table' }
      },
      {
        path: 'project',
        name: 'Project',
        component: () => import('@/views/dataBoard/project'),
        meta: { title: '项目分析', icon: 'table' }
      },
      {
        path: 'service',
        name: 'Service',
        component: () => import('@/views/dataBoard/service'),
        meta: { title: '服务分析', icon: 'table' }
      },
      {
        path: 'human',
        name: 'Human',
        component: () => import('@/views/dataBoard/human'),
        meta: { title: '人效分析', icon: 'table' }
      },
      {
        path: 'onlineService',
        name: 'OnlineService',
        component: () => import('@/views/dataBoard/onlineService'),
        meta: { title: '线上服务分析', icon: 'table' }
      },
      {
        path: 'learn',
        name: 'DataBoardLearn',
        component: () => import('@/views/dataBoard/learn'),
        meta: { title: '学习监管', icon: 'table' }
      },
    ]
  },
  {
    path: '/live',
    component: Layout,
    meta: { title: '直播管理', icon: 'table' },
    children: [
      {
        path: 'liveStatistics',
        name: 'LiveStatistics',
        component: () => import('@/views/live/liveStatistics'),
        meta: { title: '直播统计', icon: 'table' }
      },
      {
        path: 'liveAnchor',
        name: 'LiveAnchor',
        component: () => import('@/views/live/liveAnchor'),
        meta: { title: '主播', icon: 'table' }
      },
      {
        path: 'liveStreaming',
        name: 'LiveStreaming',
        component: () => import('@/views/live/liveStreaming'),
        meta: { title: '直播中', icon: 'table' }
      },
      {
        path: 'intentDepositConfig/log',
        name: 'IntentDepositConfigLog',
        component: () => import('@/views/live/intentDepositConfig/log'),
        meta: { title: '意向金配置日志', icon: 'table' },
        hidden: true
      },
      {
        path: 'liveStreaming/console',
        name: 'LiveConsole',
        component: () => import('@/views/live/liveStreaming/console'),
        meta: { title: '控制台', icon: 'table', breadcrumb: false },
        hidden: true
      },
      {
        path: 'liveReward',
        name: 'LiveReward',
        component: () => import('@/views/live/liveReward'),
        meta: { title: '打赏记录', icon: 'table' }
      },
      {
        path: 'liveBag',
        name: 'LiveBag',
        component: () => import('@/views/live/liveBag'),
        meta: { title: '直播福袋', icon: 'table' }
      },
      {
        path: 'livePreview',
        name: 'LivePreview',
        component: () => import('@/views/live/livePreview'),
        meta: { title: '直播预告', icon: 'table' }
      },
      {
        path: 'liveReplay',
        name: 'LiveReplay',
        component: () => import('@/views/live/liveReplay'),
        meta: { title: '回放管理', icon: 'table' }
      },
      {
        path: 'liveEmoji',
        name: 'LiveEmoji',
        component: () => import('@/views/live/liveEmoji'),
        meta: { title: '表情包', icon: 'table' }
      },
      {
        path: 'liveRewardConfig',
        name: 'LiveRewardConfig',
        component: () => import('@/views/live/liveRewardConfig'),
        meta: { title: '打赏配置', icon: 'table' }
      },
      {
        path: 'liveActive',
        name: 'LiveActive',
        component: () => import('@/views/live/liveActive'),
        meta: { title: '用户活跃度', icon: 'table' }
      },
      {
        path: 'liveActive/show',
        name: 'LiveActiveShow',
        component: () => import('@/views/live/liveActive/show'),
        meta: { title: '用户活跃度详情', icon: 'table' },
        hidden: true
      },
      {
        path: 'liveView',
        name: 'LiveView',
        component: () => import('@/views/live/liveView'),
        meta: { title: '直播间观看人数', icon: 'table' }
      }
    ]
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// 导出路由配置供其他模块使用
export const constRoutes = constantRoutes
export const asyncRoutes = []

export default router
